import { Navigate } from 'react-router-dom';
import { useGetUser } from '@/hooks';
import { ROUTES } from '@/constants/constants';

/**
 * Redirects /cdk index to dashboard or dashboard/:companyId.
 */
export function CdkRedirect() {
  const { currentUser } = useGetUser();

  if (!currentUser) return null;

  const to =
    currentUser.type === 'final_owner'
      ? `${ROUTES.CDK}/${ROUTES.DASHBOARD}`
      : `${ROUTES.CDK}/${ROUTES.DASHBOARD}/${currentUser.companyId ?? ''}`;

  return <Navigate to={to} replace />;
}
